export interface Facility {
  id: string;
  name: string;
  desc: string;
  image: string;
}

export interface Equipment {
  id: string;
  icon: string;
  name: string;
  desc: string;
}

export const storyParagraphs: string[] = [
  "비앙카 피부관리는 '피부 고민은 마음의 고민'이라는 믿음에서 시작되었습니다. 피부가 힘들면 마음까지 움츠러들기 마련이죠. 저희는 단순히 피부만 관리하는 것이 아니라, 고객님의 하루에 자신감과 편안함을 되돌려드리고 싶습니다.",
  "10년이 넘는 시간 동안 한결같이 피부와 마주해온 전문 관리사가, 최신 장비와 검증된 프리미엄 제품을 바탕으로 고객님 한 분 한 분의 피부에 진심으로 집중합니다. 유행하는 관리가 아닌, 고객님의 피부에 꼭 필요한 관리를 제안하는 것이 비앙카의 철학입니다.",
  "바쁜 일상 속에서 잠시 숨을 고르는 시간, 비앙카는 그 쉼표가 되어드리고 싶습니다. 편안한 공간과 따뜻한 손길로, 건강하고 빛나는 피부와 함께 마음의 여유까지 선물해드립니다.",
];

export const facilities: Facility[] = [
  {
    id: "lounge",
    name: "상담 라운지",
    desc: "편안한 분위기에서 피부 고민을 충분히 나눌 수 있는 프라이빗 상담 공간입니다.",
    image: "https://readdy.ai/api/search-image?query=Cozy%20elegant%20beauty%20salon%20consultation%20lounge%20with%20soft%20dusty%20pink%20armchairs%20warm%20wooden%20accents%20and%20gentle%20ambient%20lighting%20minimalist%20interior%20design%20serene%20spa%20atmosphere%20bright%20airy%20space%20with%20subtle%20floral%20decor%20editorial%20photography&width=800&height=600&seq=bianca-facility-lounge&orientation=landscape",
  },
  {
    id: "treatment",
    name: "프라이빗 관리실",
    desc: "개별 관리실에서 타인의 시선 없이 온전히 휴식하며 관리를 받으실 수 있습니다.",
    image: "https://readdy.ai/api/search-image?query=Serene%20private%20skincare%20treatment%20room%20with%20comfortable%20treatment%20bed%20soft%20white%20linens%20warm%20lighting%20and%20minimal%20spa%20decor%20in%20dusty%20pink%20and%20cream%20tones%20clean%20bright%20peaceful%20atmosphere%20editorial%20interior%20photography&width=800&height=600&seq=bianca-facility-treatment&orientation=landscape",
  },
  {
    id: "rest",
    name: "휴식 공간",
    desc: "관리 전후로 따뜻한 차와 함께 몸과 마음을 쉬어갈 수 있는 아늑한 공간입니다.",
    image: "https://readdy.ai/api/search-image?query=Tranquil%20relaxation%20corner%20in%20a%20beauty%20spa%20with%20soft%20seating%20warm%20herbal%20tea%20and%20gentle%20natural%20light%20in%20pastel%20pink%20and%20beige%20tones%20minimalist%20cozy%20atmosphere%20bright%20serene%20editorial%20photography&width=800&height=600&seq=bianca-facility-rest&orientation=landscape",
  },
  {
    id: "powder",
    name: "파우더룸",
    desc: "관리 후 간단히 정돈하고 메이크업까지 마무리할 수 있도록 준비된 공간입니다.",
    image: "https://readdy.ai/api/search-image?query=Bright%20elegant%20powder%20room%20in%20a%20skincare%20spa%20with%20clean%20vanity%20mirror%20soft%20lighting%20and%20minimalist%20cosmetic%20arrangement%20in%20blush%20pink%20and%20white%20tones%20refined%20serene%20atmosphere%20editorial%20interior%20photography&width=800&height=600&seq=bianca-facility-powder&orientation=landscape",
  },
];

export const equipments: Equipment[] = [
  { id: "e1", icon: "ri-scan-2-line", name: "피부 진단 장비", desc: "수분, 유분, 탄력, 색소 등 피부 상태를 정밀하게 분석해 맞춤 관리를 설계합니다." },
  { id: "e2", icon: "ri-flashlight-line", name: "초음파 이온 관리기", desc: "유효 성분을 피부 깊숙이 침투시켜 흡수력을 높여주는 장비입니다." },
  { id: "e3", icon: "ri-sun-line", name: "LED 광선 마스크", desc: "피부 진정과 재생을 돕는 광선 케어로 관리 효과를 배가시킵니다." },
  { id: "e4", icon: "ri-pulse-line", name: "고주파 리프팅 장비", desc: "피부 심부에 열 에너지를 전달해 탄력과 리프팅을 돕습니다." },
  { id: "e5", icon: "ri-cloud-line", name: "온열 스팀기", desc: "모공을 부드럽게 열어 딥클렌징 효과를 높여주는 장비입니다." },
  { id: "e6", icon: "ri-heart-pulse-line", name: "냉각 진정 장비", desc: "관리 후 피부를 차분하게 가라앉혀 진정과 마무리를 돕습니다." },
];